import {
  ACTION_KEY,
  ACTION_SELECTED_ID_KEY,
  PARENT_ID_KEY,
  endpoints,
} from "config";
import { ViewedProjectData } from "../LastViewedProjects";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setActionID,
  setActionKey,
  setTemporaryFilters,
} from "reducers/redirect";
import {
  setProgrammeId,
  setRedirectUrl,
  setRedirectUrlDestinationModule,
} from "reducers/listPage";
import { gatewayClass } from "pages/ProjectManagement/components/Overview/GatewaySummary";

export const SimpleProjectCard = (
  projectProps: ViewedProjectData & { permission?: boolean }
) => {
  const {
    projects__Id,
    programmes__Name,
    permission,
    programmes__Id,
    projects__CompletedGateways,
    projects__TotalGateways,
    projectStatusTypes__Status,
    sites__Name,
    sites__Id,
    sites__ClientId, 
  } = projectProps;

  const [navigated, setNavigated] = useState<boolean>(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <div className={"SimpleProjectCardContainer"}>
      <div className="BodyContainer">
        <div
          className={`Progress ${gatewayClass(
            projects__CompletedGateways ?? 0,
            projects__TotalGateways ?? 0
          )}`}
        >
          <div className="Count">{`${projects__CompletedGateways ??
            "-"}/${projects__TotalGateways ?? "-"}`}</div>
        </div>

        <h3 className="Title">{sites__Name ?? "-"}</h3>

        <div className="BadgeContainer">
          <div className="SiteIdBadge">
            <div className="Text">{sites__Id ?? "-"}</div>
          </div>
          <div className="ClientIdBadge">
            <div className="Text">{sites__ClientId ?? "-"}</div>
          </div>
        </div>

        <div className="Programme">{programmes__Name ?? "-"}</div>

        <div className="ProjectStatus">
          <span>Project Status:</span>
          {`${projectStatusTypes__Status ?? "-"}`}
        </div>
      </div>

      <div className="FooterContainer">
        <div
          className={`Btn ${!permission ? "Disabled" : ""}`}
          onClick={() => {
            window.localStorage.setItem(ACTION_KEY, "VIEW");

            window.localStorage.setItem(
              ACTION_SELECTED_ID_KEY,
              String(projects__Id)
            );

            window.localStorage.setItem(PARENT_ID_KEY, String(programmes__Id));

            if (programmes__Id) {
            }

            dispatch(setActionKey("VIEW"));
            dispatch(setTemporaryFilters(true));
            dispatch(setRedirectUrlDestinationModule("/projectmanagement"));
            dispatch(
              setRedirectUrl(
                `${endpoints.projectmanagement.list}?bTemporaryFilters=true&ProgrammesId=${programmes__Id}&bClearSearch=true&filters=Projects__ID+EQ+(${projects__Id})`
              )
            );
            navigate("/projectmanagement");
          }}
        >
          View
        </div>
      </div>
    </div>
  );
};
